import { LoaderCircle } from "lucide-react"

// The cost / discount / total breakdown a request form shows before the
// customer commits. Three lines, the same three the legacy modals show, and
// every number comes from the server's calculator — nothing here does
// arithmetic of its own.
//
// `loading` dims the figures while a new quote is on its way rather than
// blanking them, so changing the hours doesn't make the price flicker away.
export default function RequestCost({ pricing, loading = false }) {
  if (!pricing?.total) return null

  const discounted = Number(pricing.discount) > 0

  return (
    <div className="relative flex flex-col gap-1.5 rounded-xl border border-border bg-accent px-3.5 py-3 text-[13px]">
      {loading && (
        <LoaderCircle
          className="absolute top-3 right-3.5 size-3.5 animate-spin text-ink-3"
          aria-label="Updating the price"
        />
      )}
      <div className={loading ? "opacity-55 transition-opacity" : "transition-opacity"}>
        <div className="flex items-baseline justify-between text-muted-foreground">
          <span>Cost</span>
          <span className="tabular-nums">${pricing.total}</span>
        </div>
        <div className="mt-1.5 flex items-baseline justify-between text-muted-foreground">
          <span>Discount</span>
          <span className="tabular-nums">{discounted ? `−$${pricing.discount}` : "−$0.00"}</span>
        </div>
        <div className="mt-1.5 flex items-baseline justify-between border-t border-border pt-1.5">
          <span className="font-semibold">Total</span>
          <span
            data-testid="request-total"
            className="font-display text-[18px] font-semibold tracking-[-0.3px] tabular-nums"
          >
            ${pricing.totalWithDiscount}
          </span>
        </div>
      </div>
    </div>
  )
}
